import Link from 'next/link';
import { useTranslation } from 'next-export-i18n';
import React, { useCallback } from 'react';

import { logCustomEvent } from '@/utils/analytic';
import { AnalyticEvent } from '@/utils/enum';

type ButtonLinkProps = {
  label: string;
  link: string;
  isOpenNewTab?: boolean;
  type?: 'primary' | 'outline';
};

const ButtonLink = ({
  link,
  label,
  isOpenNewTab = true,
  type = 'primary',
}: ButtonLinkProps) => {
  const { t } = useTranslation();
  const getButtonStyle = () => {
    switch (type) {
      case 'outline':
        return 'border border-black hover:bg-black hover:text-white';

      default:
        return 'bg-slate-900 hover:bg-slate-800 text-white';
    }
  };

  const getEventName = useCallback(() => {
    switch (label) {
      case t('company.visitWebsite'):
        return AnalyticEvent.ViewCompanyWebsite;

      case t('company.visitCareerPage'):
        return AnalyticEvent.ViewCompanyCareerPage;

      default:
        return AnalyticEvent.ContactCompany;
    }
  }, []);

  const btnType = getButtonStyle();
  const eventName = getEventName();

  return (
    <Link href={link}>
      <a
        href={link}
        className={`block rounded-full py-2 px-5 text-center text-base ${btnType}`}
        target={!isOpenNewTab ? '_self' : '_blank'}
        rel="noreferrer"
        onClick={() => logCustomEvent(eventName)}
      >
        {label}
      </a>
    </Link>
  );
};

export default ButtonLink;
